// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2ScSh","rootSmall":"AddTileButton_rootSmall__3qrvg"};